export const numberWithSpaces = (value) => {
    return value
        .toString()
        .replace(/[^0-9]/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

window.utils = {
    numberWithSpaces,
};
